import gql from 'graphql-tag';
import {
  orderCustomerFragment,
  orderItemFragment,
  transactionFragment,
} from '../../actions/graphql';

export const GET_GIFTCARDS = gql`
  query getGiftcards($search: String, $filterScope: GiftcardFilterScope) {
    giftcards(search: $search, filterScope: $filterScope) {
      id
      code
      status
      remainingAmount
    }
  }
`;

export const GET_PREPAID_CARDS = gql`
  query getPrepaidCards($customerId: ID, $filterScope: PrepaidCardFilterScope) {
    prepaidCards(customerId: $customerId, filterScope: $filterScope) {
      id
      description
      quantity
      used
      remaining
      price
      status
      pricePerUse
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query getPaymentMethods($register: Boolean, $locationId: ID) {
    paymentMethods(register: $register, locationId: $locationId)
  }
`;

export const LISTEN_TO_POS_TERMINAL_PAYMENT = gql`
  subscription listenToPosTerminalPayment {
    posTerminalPayment {
      status
      order {
        id
        number
        invoicedAt
        pending
        fiscalizationFinished
        state
        transactions {
          ...transaction
        }
        items {
          ...orderItem
        }
        customer {
          ...orderCustomer
        }
      }
      refusalReason
      tipAmount
    }
  }
  ${transactionFragment}
  ${orderItemFragment}
  ${orderCustomerFragment}
`;

export const GENERATE_POS_PAYMENT = gql`
  mutation generatePosPayment($input: GeneratePosPaymentInput!) {
    generatePosPayment(input: $input) {
      error {
        message
      }
      posPaymentId
    }
  }
`;

export const VERIFY_POS_PAYMENT = gql`
  mutation verifyPosPayment($input: VerifyPosPaymentInput!) {
    verifyPosPayment(input: $input) {
      error {
        message
      }
      posPayment {
        id
        orderId
        amount
        tipAmount
        transactionFee
        status
        createdAt
      }
      order {
        id
        number
        invoicedAt
        pending
        state
        transactions {
          ...transaction
        }
        items {
          ...orderItem
        }
        customer {
          ...orderCustomer
        }
      }
    }
  }
  ${transactionFragment}
  ${orderItemFragment}
  ${orderCustomerFragment}
`;

export const GET_ORDER = gql`
  query getOrder($id: ID!) {
    order(id: $id) {
      id
      number
      invoicedAt
      pending
      state
      transactions {
        ...transaction
      }
      items {
        ...orderItem
      }
      customer {
        ...orderCustomer
      }
    }
  }
  ${transactionFragment}
  ${orderItemFragment}
  ${orderCustomerFragment}
`;
